import { createComponentStore } from './createComponentStore';
export const useDecisionGridActionsComponentStore = createComponentStore('decisionGridActionsComponentStore');
